// src/utils/auth.js
export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user"));
  } catch {
    return null;
  }
};

export const getUserProfile = () => {
  return getUser()?.perfil;
};
